export default "__VITE_ASSET__CVRQruIc__"